import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '@woolworthsnz/styleguide';

@Component({
	selector: 'search-error',
	standalone: true,
	imports: [ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<article class="search-error-container">
			<h1 class="heading--huge">Something went wrong</h1>
			<p>Please refresh the page and try again.</p>
			<button cdxButton class="search-error-button" (click)="reload()">Refresh</button>
		</article>
	`,
	styleUrls: ['search-error.component.scss'],
})
export class SearchErrorComponent {
	reload(): void {
		window.location.reload();
	}
}
